// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"polyfills-dom":"d6796109a7cb09f9","polyfills-core-js":"9526d82ee2ab2479","node_modules_profabric_web-components_dist_esm_pf-button_6_entry_js":"ac922e3341231e20"}[chunkId] + ".js";
};